import { ExperimentDefinition } from '../experiments.types'

const EXPERIMENTS = {
  PDP_PARTNER_REC: {
    experimentName: 'pdp-partner-rec',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  SHOW_SIMILAR_EXP: {
    experimentName: 'show-similar-exp',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  PDP_REC_MODULES: {
    experimentName: 'pdp-rec-modules',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  CART_HURRY_MSG: {
    experimentName: 'cart-hurry-msg',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  DEFAULT_CART_RECOMMENDATION: {
    experimentName: 'default-cart-recommendation',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  PREORDER: {
    experimentName: 'preorder',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  CATEGORY_AND_DEPTS_FILTER_EXP: {
    experimentName: 'category-and-departments-filter',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  HOUSE_KEEPING_AWARD: {
    experimentName: 'housekeeing-award',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  VDAY_CUTOFF_MESSAGE: {
    experimentName: 'vday-cutoff-message',
    bucketNames: {
      control: 'control',
      showDate: 'showDate',
      showArrival: 'showArrival',
    },
  },
  PDP_NEW_TAB: {
    experimentName: 'pdp-new-tab',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  FREE_TOTE: {
    experimentName: 'free-tote',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  MINI_PDP: {
    experimentName: 'mini-pdp',
    bucketNames: {
      control: 'control',
      testA: 'testA',
      testB: 'testB',
    },
  },
  STICKY_ATC_A: {
    experimentName: 'sticky-atc-a',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  ALL_DEPT_SHOP: {
    experimentName: 'all-dept-shop',
    date: '2024-14-03',
    bucketNames: {
      control: 'control',
      text: 'text',
      image: 'image',
    },
  },
  BESTSELLER_PRODUCT_DIVERSITY: {
    experimentName: 'bestseller-product-diversity',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  PDP_COMPARISION_SECTION: {
    experimentName: 'pdp-comparison-section',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  OFF_SHOPIFY_CHECKOUT: {
    experimentName: 'offshopify',
    bucketNames: {
      show: 'show',
      baseline: 'baseline',
    },
  },
  CHECKOUT_CARD_POPUP: {
    experimentName: 'checkout-card-popup',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  REVIEW_HIGHLIGHTS_MOBILE: {
    experimentName: 'review-highlights-mobile',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  REWARD_CREDIT_ON_CARTPAGE: {
    experimentName: 'reward-credit-on-cartpage',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  CREDIT_TAGS_ON_PRODUCT_CARD: {
    experimentName: 'credit-tags-on-product-card',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  EXPAND_NEW_AND_NOTEWORTHY: {
    experimentName: 'expand-new-and-noteworthy-mobile',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  SHOW_ATC_ON_MOBILE: {
    experimentName: 'show-atc-on-mobile',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  UGC_VIDEO_ON_PDP_IMAGE_CAROUSEL: {
    experimentName: 'ugc-video-on-pdp-image-carousel',
    bucketNames: {
      variantA: 'variantA',
      control: 'control',
    },
  },
} satisfies Record<string, ExperimentDefinition>

export default EXPERIMENTS
